// extracted by mini-css-extract-plugin
export const root = "figure-module--root--1FgYF";
export const small = "figure-module--small--2HUda";
export const medium = "figure-module--medium--2zA_0";
export const large = "figure-module--large--UeclS";